import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import AES from '@/assets/util/AES';
import { getBannerList, getActor, postFirend, getHeader, getNewlist, getYear, OpenGUIDFile, getPDF, getPDFnew, getHtmlRead, getList, getLista, getListb, getXZCS, getPLLB, postMassage, postSearch, postThirdRegister, getLBXQ, getXZPH, getDCJK, getWZDC, getgok, getSet, getLLCS, getAllSum, postLogin, getVerificationcode, getRegDeteCt, getForgetPassword, getForgetPasswordGroup, getIsRegistered, getRegSendCode, postRegist, getLM, getSFXS, postNDCJ, GetRouter, getXKLX, getdetailes, getOAViewTJ, GetRss, GetRssycb, GetscriptRssycb, getGetQrcode, GetToken, getWeiXinLogin, GetFloatingAds, getdownXML, getMMDL, GetScriptPrePrintDetailed, IssueDownLoad, OpenFilebyGuid, OpenMessageFilebyGuid, EamilVerification, NoLoginChangePassword, GetYearIssueList, GetArticleIDByNum, PostSubscribe, UnSubscribe, GetIssueList, getReSetPassword, ForgetPasswordByGuid } from "@/assets/util/Link";
var Admin = {
  //高级检索学科领域是否显示
  _getMMDL: function () {
    var _getMMDL2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(state, data) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", getMMDL(data));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function _getMMDL(_x, _x2) {
      return _getMMDL2.apply(this, arguments);
    }

    return _getMMDL;
  }(),
  //高级检索学科领域是否显示
  _getXKLX: function () {
    var _getXKLX2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(state, data) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", getXKLX(data));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function _getXKLX(_x3, _x4) {
      return _getXKLX2.apply(this, arguments);
    }

    return _getXKLX;
  }(),
  //高级检索栏目领域是否显示
  _getSFXS: function () {
    var _getSFXS2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(state, data) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", getSFXS(data));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function _getSFXS(_x5, _x6) {
      return _getSFXS2.apply(this, arguments);
    }

    return _getSFXS;
  }(),
  //预出版详情
  _GetScriptPrePrintDetailed: function () {
    var _GetScriptPrePrintDetailed2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(state, data) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", GetScriptPrePrintDetailed(data));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function _GetScriptPrePrintDetailed(_x7, _x8) {
      return _GetScriptPrePrintDetailed2.apply(this, arguments);
    }

    return _GetScriptPrePrintDetailed;
  }(),
  //年度区间接口
  _postNDCJ: function () {
    var _postNDCJ2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(state, data) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", postNDCJ(data));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function _postNDCJ(_x9, _x10) {
      return _postNDCJ2.apply(this, arguments);
    }

    return _postNDCJ;
  }(),
  //高级检索栏目接口
  _getLM: function () {
    var _getLM2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(state, data) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", getLM(data));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function _getLM(_x11, _x12) {
      return _getLM2.apply(this, arguments);
    }

    return _getLM;
  }(),
  //注册
  _postRegist: function () {
    var _postRegist2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(state, data) {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", postRegist(data));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function _postRegist(_x13, _x14) {
      return _postRegist2.apply(this, arguments);
    }

    return _postRegist;
  }(),
  _GetRouter: function () {
    var _GetRouter2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(state, data) {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", GetRouter(data));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function _GetRouter(_x15, _x16) {
      return _GetRouter2.apply(this, arguments);
    }

    return _GetRouter;
  }(),
  _GetRss: function () {
    var _GetRss2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(state, data) {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", GetRss(data));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function _GetRss(_x17, _x18) {
      return _GetRss2.apply(this, arguments);
    }

    return _GetRss;
  }(),
  _GetRssycb: function () {
    var _GetRssycb2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee10(state, data) {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", GetRssycb(data));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function _GetRssycb(_x19, _x20) {
      return _GetRssycb2.apply(this, arguments);
    }

    return _GetRssycb;
  }(),
  _GetscriptRssycb: function () {
    var _GetscriptRssycb2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee11(state, data) {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", GetscriptRssycb(data));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function _GetscriptRssycb(_x21, _x22) {
      return _GetscriptRssycb2.apply(this, arguments);
    }

    return _GetscriptRssycb;
  }(),
  //发送验证码
  _getRegSendCode: function () {
    var _getRegSendCode2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee12(state, data) {
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", getRegSendCode(data));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function _getRegSendCode(_x23, _x24) {
      return _getRegSendCode2.apply(this, arguments);
    }

    return _getRegSendCode;
  }(),
  //找回密码
  _getForgetPassword: function () {
    var _getForgetPassword2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee13(state, data) {
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", getForgetPassword(data));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function _getForgetPassword(_x25, _x26) {
      return _getForgetPassword2.apply(this, arguments);
    }

    return _getForgetPassword;
  }(),
  _getReSetPassword: function () {
    var _getReSetPassword2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee14(state, data) {
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", getReSetPassword(data));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function _getReSetPassword(_x27, _x28) {
      return _getReSetPassword2.apply(this, arguments);
    }

    return _getReSetPassword;
  }(),
  _ForgetPasswordByGuid: function () {
    var _ForgetPasswordByGuid2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee15(state, data) {
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", ForgetPasswordByGuid(data));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function _ForgetPasswordByGuid(_x29, _x30) {
      return _ForgetPasswordByGuid2.apply(this, arguments);
    }

    return _ForgetPasswordByGuid;
  }(),
  _getForgetPasswordGroup: function () {
    var _getForgetPasswordGroup2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee16(state, data) {
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", getForgetPasswordGroup(data));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    function _getForgetPasswordGroup(_x31, _x32) {
      return _getForgetPasswordGroup2.apply(this, arguments);
    }

    return _getForgetPasswordGroup;
  }(),
  //找回密码页面添加相同邮箱和手机号所有账号列表
  _getIsRegistered: function () {
    var _getIsRegistered2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee17(state, data) {
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", getIsRegistered(data));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    function _getIsRegistered(_x33, _x34) {
      return _getIsRegistered2.apply(this, arguments);
    }

    return _getIsRegistered;
  }(),
  //判断手机号邮箱是否注册过
  _getRegDeteCt: function () {
    var _getRegDeteCt2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee18(state, data) {
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", getRegDeteCt(data));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    function _getRegDeteCt(_x35, _x36) {
      return _getRegDeteCt2.apply(this, arguments);
    }

    return _getRegDeteCt;
  }(),
  //获取页面验证码
  _getVerificationcode: function () {
    var _getVerificationcode2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee19(state, data) {
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", getVerificationcode(data));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    function _getVerificationcode(_x37, _x38) {
      return _getVerificationcode2.apply(this, arguments);
    }

    return _getVerificationcode;
  }(),
  //登录
  _postLogin: function () {
    var _postLogin2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee20(state, data) {
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", postLogin(data));

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    function _postLogin(_x39, _x40) {
      return _postLogin2.apply(this, arguments);
    }

    return _postLogin;
  }(),
  //文献导出
  _getWZDC: function () {
    var _getWZDC2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee21(state, data) {
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", getWZDC(data));

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    function _getWZDC(_x41, _x42) {
      return _getWZDC2.apply(this, arguments);
    }

    return _getWZDC;
  }(),
  //
  _getDCJK: function () {
    var _getDCJK2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee22(state, data) {
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", getDCJK(data));

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    function _getDCJK(_x43, _x44) {
      return _getDCJK2.apply(this, arguments);
    }

    return _getDCJK;
  }(),
  //检索
  _getXZPH: function () {
    var _getXZPH2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee23(state, data) {
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", getXZPH(data));

            case 1:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    function _getXZPH(_x45, _x46) {
      return _getXZPH2.apply(this, arguments);
    }

    return _getXZPH;
  }(),
  //检索
  _postSearch: function () {
    var _postSearch2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee24(state, data) {
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              return _context24.abrupt("return", postSearch(data));

            case 1:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    function _postSearch(_x47, _x48) {
      return _postSearch2.apply(this, arguments);
    }

    return _postSearch;
  }(),
  //qq登录
  _postThirdRegister: function () {
    var _postThirdRegister2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee25(state, data) {
      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              return _context25.abrupt("return", postThirdRegister(data));

            case 1:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    function _postThirdRegister(_x49, _x50) {
      return _postThirdRegister2.apply(this, arguments);
    }

    return _postThirdRegister;
  }(),
  // 获取轮播图
  _getBannerList: function () {
    var _getBannerList2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee26(state, data) {
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              return _context26.abrupt("return", getBannerList(data));

            case 1:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    function _getBannerList(_x51, _x52) {
      return _getBannerList2.apply(this, arguments);
    }

    return _getBannerList;
  }(),
  //期刊社动态/作者营地
  _getActor: function () {
    var _getActor2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee27(state, data) {
      return regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              return _context27.abrupt("return", getActor(data));

            case 1:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    function _getActor(_x53, _x54) {
      return _getActor2.apply(this, arguments);
    }

    return _getActor;
  }(),
  //友情链接
  _postFirend: function () {
    var _postFirend2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee28(state, data) {
      return regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              return _context28.abrupt("return", postFirend(data));

            case 1:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    function _postFirend(_x55, _x56) {
      return _postFirend2.apply(this, arguments);
    }

    return _postFirend;
  }(),
  //期刊简介
  _getHeader: function () {
    var _getHeader2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee29(state, data) {
      return regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              return _context29.abrupt("return", getHeader(data));

            case 1:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    function _getHeader(_x57, _x58) {
      return _getHeader2.apply(this, arguments);
    }

    return _getHeader;
  }(),
  //首页最新一期
  _getNewlist: function () {
    var _getNewlist2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee30(state, data) {
      return regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              return _context30.abrupt("return", getNewlist(data));

            case 1:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    function _getNewlist(_x59, _x60) {
      return _getNewlist2.apply(this, arguments);
    }

    return _getNewlist;
  }(),
  //最新一期
  _getYear: function () {
    var _getYear2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee31(state, data) {
      return regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              return _context31.abrupt("return", getYear(data));

            case 1:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    function _getYear(_x61, _x62) {
      return _getYear2.apply(this, arguments);
    }

    return _getYear;
  }(),
  //首页封面，封底，目次打开文件
  _OpenGUIDFile: function () {
    var _OpenGUIDFile2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee32(state, data) {
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              return _context32.abrupt("return", OpenGUIDFile(data));

            case 1:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    function _OpenGUIDFile(_x63, _x64) {
      return _OpenGUIDFile2.apply(this, arguments);
    }

    return _OpenGUIDFile;
  }(),
  //下载pdf
  _getPDF: function () {
    var _getPDF2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee33(state, data) {
      return regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              data.Id = AES.encrypt(data.Id.toString(), "Samson*@Samson*@");
              return _context33.abrupt("return", getPDF(data));

            case 2:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    function _getPDF(_x65, _x66) {
      return _getPDF2.apply(this, arguments);
    }

    return _getPDF;
  }(),
  //下载pdfnew
  _getPDFnew: function () {
    var _getPDFnew2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee34(state, data) {
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              //data.Id=AES.encrypt((data.Id).toString(),"Samson*@Samson*@")
              data.Id = data.Id;
              return _context34.abrupt("return", getPDFnew(data));

            case 2:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34);
    }));

    function _getPDFnew(_x67, _x68) {
      return _getPDFnew2.apply(this, arguments);
    }

    return _getPDFnew;
  }(),
  //预出版
  _getList: function () {
    var _getList2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee35(state, data) {
      return regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              return _context35.abrupt("return", getList(data));

            case 1:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35);
    }));

    function _getList(_x69, _x70) {
      return _getList2.apply(this, arguments);
    }

    return _getList;
  }(),
  //html浏览次数+1
  _getHtmlRead: function () {
    var _getHtmlRead2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee36(state, data) {
      return regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              return _context36.abrupt("return", getHtmlRead(data));

            case 1:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36);
    }));

    function _getHtmlRead(_x71, _x72) {
      return _getHtmlRead2.apply(this, arguments);
    }

    return _getHtmlRead;
  }(),
  _getLista: function () {
    var _getLista2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee37(state, data) {
      return regeneratorRuntime.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              return _context37.abrupt("return", getLista(data));

            case 1:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37);
    }));

    function _getLista(_x73, _x74) {
      return _getLista2.apply(this, arguments);
    }

    return _getLista;
  }(),
  _getListb: function () {
    var _getListb2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee38(state, data) {
      return regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              return _context38.abrupt("return", getListb(data));

            case 1:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38);
    }));

    function _getListb(_x75, _x76) {
      return _getListb2.apply(this, arguments);
    }

    return _getListb;
  }(),
  _getXZCS: function () {
    var _getXZCS2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee39(state, data) {
      return regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              return _context39.abrupt("return", getXZCS(data));

            case 1:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39);
    }));

    function _getXZCS(_x77, _x78) {
      return _getXZCS2.apply(this, arguments);
    }

    return _getXZCS;
  }(),
  _getLBXQ: function () {
    var _getLBXQ2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee40(state, data) {
      return regeneratorRuntime.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              return _context40.abrupt("return", getLBXQ(data));

            case 1:
            case "end":
              return _context40.stop();
          }
        }
      }, _callee40);
    }));

    function _getLBXQ(_x79, _x80) {
      return _getLBXQ2.apply(this, arguments);
    }

    return _getLBXQ;
  }(),
  _getPLLB: function () {
    var _getPLLB2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee41(state, data) {
      return regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              return _context41.abrupt("return", getPLLB(data));

            case 1:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee41);
    }));

    function _getPLLB(_x81, _x82) {
      return _getPLLB2.apply(this, arguments);
    }

    return _getPLLB;
  }(),
  _getdownXML: function () {
    var _getdownXML2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee42(state, data) {
      return regeneratorRuntime.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              return _context42.abrupt("return", getdownXML(data));

            case 1:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee42);
    }));

    function _getdownXML(_x83, _x84) {
      return _getdownXML2.apply(this, arguments);
    }

    return _getdownXML;
  }(),
  _postMassage: function () {
    var _postMassage2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee43(state, data) {
      return regeneratorRuntime.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              return _context43.abrupt("return", postMassage(data));

            case 1:
            case "end":
              return _context43.stop();
          }
        }
      }, _callee43);
    }));

    function _postMassage(_x85, _x86) {
      return _postMassage2.apply(this, arguments);
    }

    return _postMassage;
  }(),
  _getgok: function () {
    var _getgok2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee44(state, data) {
      return regeneratorRuntime.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              return _context44.abrupt("return", getgok(data));

            case 1:
            case "end":
              return _context44.stop();
          }
        }
      }, _callee44);
    }));

    function _getgok(_x87, _x88) {
      return _getgok2.apply(this, arguments);
    }

    return _getgok;
  }(),
  _getSet: function () {
    var _getSet2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee45(state, data) {
      return regeneratorRuntime.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              return _context45.abrupt("return", getSet(data));

            case 1:
            case "end":
              return _context45.stop();
          }
        }
      }, _callee45);
    }));

    function _getSet(_x89, _x90) {
      return _getSet2.apply(this, arguments);
    }

    return _getSet;
  }(),
  _getLLCS: function () {
    var _getLLCS2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee46(state, data) {
      return regeneratorRuntime.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              return _context46.abrupt("return", getLLCS(data));

            case 1:
            case "end":
              return _context46.stop();
          }
        }
      }, _callee46);
    }));

    function _getLLCS(_x91, _x92) {
      return _getLLCS2.apply(this, arguments);
    }

    return _getLLCS;
  }(),
  _getOAViewTJ: function () {
    var _getOAViewTJ2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee47(state, data) {
      return regeneratorRuntime.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              return _context47.abrupt("return", getOAViewTJ(data));

            case 1:
            case "end":
              return _context47.stop();
          }
        }
      }, _callee47);
    }));

    function _getOAViewTJ(_x93, _x94) {
      return _getOAViewTJ2.apply(this, arguments);
    }

    return _getOAViewTJ;
  }(),
  _getAllSum: function () {
    var _getAllSum2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee48(state, data) {
      return regeneratorRuntime.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              return _context48.abrupt("return", getAllSum(data));

            case 1:
            case "end":
              return _context48.stop();
          }
        }
      }, _callee48);
    }));

    function _getAllSum(_x95, _x96) {
      return _getAllSum2.apply(this, arguments);
    }

    return _getAllSum;
  }(),
  //首页广告获取
  _GetFloatingAds: function () {
    var _GetFloatingAds2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee49(state, data) {
      return regeneratorRuntime.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              return _context49.abrupt("return", GetFloatingAds(data));

            case 1:
            case "end":
              return _context49.stop();
          }
        }
      }, _callee49);
    }));

    function _GetFloatingAds(_x97, _x98) {
      return _GetFloatingAds2.apply(this, arguments);
    }

    return _GetFloatingAds;
  }(),
  _getdetailes: function () {
    var _getdetailes2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee50(state, data) {
      return regeneratorRuntime.wrap(function _callee50$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              return _context50.abrupt("return", getdetailes(data));

            case 1:
            case "end":
              return _context50.stop();
          }
        }
      }, _callee50);
    }));

    function _getdetailes(_x99, _x100) {
      return _getdetailes2.apply(this, arguments);
    }

    return _getdetailes;
  }(),
  //weixin登录
  _getGetQrcode: function () {
    var _getGetQrcode2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee51(state, data) {
      return regeneratorRuntime.wrap(function _callee51$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              return _context51.abrupt("return", getGetQrcode(data));

            case 1:
            case "end":
              return _context51.stop();
          }
        }
      }, _callee51);
    }));

    function _getGetQrcode(_x101, _x102) {
      return _getGetQrcode2.apply(this, arguments);
    }

    return _getGetQrcode;
  }(),
  //weixin登录
  _getWeiXinLogin: function () {
    var _getWeiXinLogin2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee52(state, data) {
      return regeneratorRuntime.wrap(function _callee52$(_context52) {
        while (1) {
          switch (_context52.prev = _context52.next) {
            case 0:
              return _context52.abrupt("return", getWeiXinLogin(data));

            case 1:
            case "end":
              return _context52.stop();
          }
        }
      }, _callee52);
    }));

    function _getWeiXinLogin(_x103, _x104) {
      return _getWeiXinLogin2.apply(this, arguments);
    }

    return _getWeiXinLogin;
  }(),
  _GetToken: function () {
    var _GetToken2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee53(state, data) {
      return regeneratorRuntime.wrap(function _callee53$(_context53) {
        while (1) {
          switch (_context53.prev = _context53.next) {
            case 0:
              return _context53.abrupt("return", GetToken(data));

            case 1:
            case "end":
              return _context53.stop();
          }
        }
      }, _callee53);
    }));

    function _GetToken(_x105, _x106) {
      return _GetToken2.apply(this, arguments);
    }

    return _GetToken;
  }(),
  _OpenFilebyGuid: function () {
    var _OpenFilebyGuid2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee54(state, data) {
      return regeneratorRuntime.wrap(function _callee54$(_context54) {
        while (1) {
          switch (_context54.prev = _context54.next) {
            case 0:
              return _context54.abrupt("return", OpenFilebyGuid(data));

            case 1:
            case "end":
              return _context54.stop();
          }
        }
      }, _callee54);
    }));

    function _OpenFilebyGuid(_x107, _x108) {
      return _OpenFilebyGuid2.apply(this, arguments);
    }

    return _OpenFilebyGuid;
  }(),
  _OpenMessageFilebyGuid: function () {
    var _OpenMessageFilebyGuid2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee55(state, data) {
      return regeneratorRuntime.wrap(function _callee55$(_context55) {
        while (1) {
          switch (_context55.prev = _context55.next) {
            case 0:
              return _context55.abrupt("return", OpenMessageFilebyGuid(data));

            case 1:
            case "end":
              return _context55.stop();
          }
        }
      }, _callee55);
    }));

    function _OpenMessageFilebyGuid(_x109, _x110) {
      return _OpenMessageFilebyGuid2.apply(this, arguments);
    }

    return _OpenMessageFilebyGuid;
  }(),
  _IssueDownLoad: function () {
    var _IssueDownLoad2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee56(state, data) {
      return regeneratorRuntime.wrap(function _callee56$(_context56) {
        while (1) {
          switch (_context56.prev = _context56.next) {
            case 0:
              return _context56.abrupt("return", IssueDownLoad(data));

            case 1:
            case "end":
              return _context56.stop();
          }
        }
      }, _callee56);
    }));

    function _IssueDownLoad(_x111, _x112) {
      return _IssueDownLoad2.apply(this, arguments);
    }

    return _IssueDownLoad;
  }(),
  _EamilVerification: function () {
    var _EamilVerification2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee57(state, data) {
      return regeneratorRuntime.wrap(function _callee57$(_context57) {
        while (1) {
          switch (_context57.prev = _context57.next) {
            case 0:
              return _context57.abrupt("return", EamilVerification(data));

            case 1:
            case "end":
              return _context57.stop();
          }
        }
      }, _callee57);
    }));

    function _EamilVerification(_x113, _x114) {
      return _EamilVerification2.apply(this, arguments);
    }

    return _EamilVerification;
  }(),
  _NoLoginChangePassword: function () {
    var _NoLoginChangePassword2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee58(state, data) {
      return regeneratorRuntime.wrap(function _callee58$(_context58) {
        while (1) {
          switch (_context58.prev = _context58.next) {
            case 0:
              return _context58.abrupt("return", NoLoginChangePassword(data));

            case 1:
            case "end":
              return _context58.stop();
          }
        }
      }, _callee58);
    }));

    function _NoLoginChangePassword(_x115, _x116) {
      return _NoLoginChangePassword2.apply(this, arguments);
    }

    return _NoLoginChangePassword;
  }(),
  _GetYearIssueList: function () {
    var _GetYearIssueList2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee59(state, data) {
      return regeneratorRuntime.wrap(function _callee59$(_context59) {
        while (1) {
          switch (_context59.prev = _context59.next) {
            case 0:
              return _context59.abrupt("return", GetYearIssueList(data));

            case 1:
            case "end":
              return _context59.stop();
          }
        }
      }, _callee59);
    }));

    function _GetYearIssueList(_x117, _x118) {
      return _GetYearIssueList2.apply(this, arguments);
    }

    return _GetYearIssueList;
  }(),
  _GetArticleIDByNum: function () {
    var _GetArticleIDByNum2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee60(state, data) {
      return regeneratorRuntime.wrap(function _callee60$(_context60) {
        while (1) {
          switch (_context60.prev = _context60.next) {
            case 0:
              return _context60.abrupt("return", GetArticleIDByNum(data));

            case 1:
            case "end":
              return _context60.stop();
          }
        }
      }, _callee60);
    }));

    function _GetArticleIDByNum(_x119, _x120) {
      return _GetArticleIDByNum2.apply(this, arguments);
    }

    return _GetArticleIDByNum;
  }(),
  _PostSubscribe: function () {
    var _PostSubscribe2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee61(state, data) {
      return regeneratorRuntime.wrap(function _callee61$(_context61) {
        while (1) {
          switch (_context61.prev = _context61.next) {
            case 0:
              return _context61.abrupt("return", PostSubscribe(data));

            case 1:
            case "end":
              return _context61.stop();
          }
        }
      }, _callee61);
    }));

    function _PostSubscribe(_x121, _x122) {
      return _PostSubscribe2.apply(this, arguments);
    }

    return _PostSubscribe;
  }(),
  _UnSubscribe: function () {
    var _UnSubscribe2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee62(state, data) {
      return regeneratorRuntime.wrap(function _callee62$(_context62) {
        while (1) {
          switch (_context62.prev = _context62.next) {
            case 0:
              return _context62.abrupt("return", UnSubscribe(data));

            case 1:
            case "end":
              return _context62.stop();
          }
        }
      }, _callee62);
    }));

    function _UnSubscribe(_x123, _x124) {
      return _UnSubscribe2.apply(this, arguments);
    }

    return _UnSubscribe;
  }(),
  _GetIssueList: function () {
    var _GetIssueList2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee63(state, data) {
      return regeneratorRuntime.wrap(function _callee63$(_context63) {
        while (1) {
          switch (_context63.prev = _context63.next) {
            case 0:
              return _context63.abrupt("return", GetIssueList(data));

            case 1:
            case "end":
              return _context63.stop();
          }
        }
      }, _callee63);
    }));

    function _GetIssueList(_x125, _x126) {
      return _GetIssueList2.apply(this, arguments);
    }

    return _GetIssueList;
  }()
};
export default Admin;